<template>
  <v-container class="power-yuri-grom">
    <!--  -->
    <v-card class="card-style text-xs-center mb-3">
      <v-card-title primary-title>
        <div>
          <h2>Сила Юрий Гром</h2>
          <p class="lead">&nbsp;&nbsp;&nbsp;&nbsp; – первая и пока единственная Держава, связанная с конкретным игровым сообществом. EG Pilots получили право на добавление своей Силы, одержав безоговорочную победу в самом масштабном ивенте за все время существования Elite Dangerous – Rise to Power, предварительно столь же убедительно выиграв отборочный тур – Wildcard. Наша Сила получила на старте всего лишь четыре подконтрольные системы, в то время, когда прочие Державы уже обладали десятками систем, но мы смогли отстоять свое право быть в ряду Галактических Сил и сейчас уже занимаем одну из высших строк в рейтинге Держав.</p>
        </div>
      </v-card-title>
    </v-card>
    <!--  -->
    <v-card class="card-style text-center mb-3 pa-4">
      <h2>НАШ ЛИДЕР</h2>
      <v-row class="fill-height align-top" justify="space-around">
        <v-col cols="10" md="4">
          <!-- <v-img class="rounded" :src="'/img/power/YuriGrom.jpg'" /> -->
          <v-img class="rounded" :src="'/img/home_cards/YuriGrom.jpg'" />
        </v-col>
        <v-col cols="12" md="8">
          <v-card-text class="lead text-left pa-0">
            <p>Юрий родился в системе Euryale на станции EG Main HQ в 3223 году.</p>
            <p>В 3244 году поступил в академию федерального флота, которую окончил с отличием.</p>
            <p>В 3265-м уже получил звание контр-адмирала и командовал одним из крейсеров Федерации.</p>
            <p>В 3270-м получил звание вице-адмирал и командовал одной из ударных групп 8 флота Федерации.</p>
            <p>В 3276-м получил звание адмирала и командовал 12 флотом Федерации.</p>
            <p>В 3287-м подал прошение на перевод в системную службу безопасности Euryale на должность командующего.</p>
            <p>В 3291-м ушел в отставку и занялся политической деятельностью в Euryale вступив United Euryale First.</p>
            <p>В 3297-м сменил прежнего главу на должности лидера фракции UEF.</p>
            <p>В 3301-м потребовал у правящей партии Future of Euryale начать процедуру выхода системы из состава Федерации.</p>
            <p>За время службы во флоте зарекомендовал себя как сильный стратег и тактик. Так же считается прекрасным дипломатом, неоднократно ему удавалось уговорить мятежные системы сдаться и сложить оружие.</p>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
    <!--  -->
    <v-card class="card-style text-center mb-3 pa-4">
      <p class="lead">
        <v-img class="rounded" :src="'/img/power/first-in-pp.jpg'" />
        <span>Командиры!</span>
        <br>
        <span>EG Pilots поздравляет Вас с занятием Державой Юрия Грома первого места в рейтинге Power Play!</span>
        <span>Мы хотим поблагодарить всех пилотов EG Pilots и их союзников, принявших участие и оказавших помощь в голосовании, в отборочной игре "Wildcard" и основной игре "Rise to Power", что позволило нам занять, по итогам этих испытаний, первое место среди всех комьюнити игры Elite: Dangerous и создать первую в истории мира державу Юрия Грома.</span>
        <br><br>
        <span>Благодарим всех неравнодушных к следующему этапу развития Державы. Выход на первое место в рейтинге среди остальных держав.</span>
        <br><br>
        <span>Стоит отметить, что на момент создания державы Юрия Грома, остальные десять держав уже как год развивались в обитаемом шаре человечества. Свободного места для нас попросту не было. Преодолевая сопротивление, проводя искусную политику, имея уверенное командование, держава Юрия Грома смогла сначала догнать ведущие державы по количеству подконтрольных систем, а потом и выйти на первое место. Это было величайшим достижением всей команды и всех тех, кто до конца шёл к цели. Спасибо всем вам!</span>
        <br><br>
        <span>Нам удалось собрать сильную и боеспособную команду готовую выполнять любые задачи, в том числе, и в опен. За это отдельное спасибо корпусу EGCF. Нам по силам справиться с любым противником, что не раз было продемонстрировано и в БГС, и в ПП.</span>
        <br><br>
        <span>В связи с достижением поставленных перед EG Pilots задач и в соответствии с решением Совета Офицеров мы завершаем проект PP в текущем формате.</span>
        <br><br>
        <span>Мы оставляем за собой право вернуться в данное направление, когда разработчики игры Frontier Developments обратят внимание на механики игры, и сделают действительно интересную и реалистичную механику Power Play.</span>
      </p>
      <!-- Видео о ПП от Гифа -->
      <div class="thumb-wrap">
        <iframe width="903" height="508" src="https://www.youtube.com/embed/zCM1OFNbc8c" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </v-card>
    <!--  -->
    <!-- <v-card class="card-style text-center mb-3 pa-4">
                <h2>ХАРАКТЕРИСТИКИ СИЛЫ</h2>
                <v-row class="fill-height align-center" justify="space-around">
                    <v-col cols="12" md="4" 
                    v-for="(char, i) in ['char_01.jpg', 'char_02.jpg', 'char_03.jpg']" 
                    :key="i" >
                        <v-img class="rounded" :src="`/img/power/${char}`" />
                    </v-col>
                </v-row>
            </v-card> -->
    <!--  -->
    <!-- 
    <v-card class="card-style text-xs-center mb-3">
      <v-card-title primary-title>
        <div>
          <h2>КАК ПРИСОЕДИНИТЬСЯ К ДЕРЖАВЕ</h2>
          <p class="lead">Если вы хотите помогать Силе Юрия Грома расти и обретать все большее влияние, то недостаточно просто присоединиться к Державе в игре. Наша главная сила – единство и координирование усилий, поэтому лучший вариант – это зайти на наш <a class="in-text-link" target="_blank" :href="linkD">Discord-сервер</a>. Мы ждем вас!</p>
        </div>
      </v-card-title>
    </v-card>
     -->
    <!--  -->
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      linkD: process.env.VUE_APP_LINK_EGP
    }
  }
}
</script>

<style scoped>
.thumb-wrap {
  position: relative;
  padding-bottom: 56.25%;
  /* задаёт высоту контейнера для 16:9 (если 4:3 — поставьте 75%) */
  height: 0;
  overflow: hidden;
}

.thumb-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-width: 0;
  outline-width: 0;
}
</style>
